import React from 'react';

const SendMessage = ({ product, vendedor }) => {
  const handleSendMessage = () => {
    const sellerPhone = vendedor?.FCTelefono;
    const sellerName = vendedor?.FCNombre || 'Vendedor';

    if (!sellerPhone) {
      alert('⚠️ El vendedor ha desactivado su número telefónico. Lo lamentamos, intenta contactarlo más tarde.');
      return;
    }

    const message = `¡Hola ${sellerName}! Vi este producto en MercanteMéxico:

 Modelo: ${product.FCNombre}
 
 Precio: $${product.FNPrecioVenta}
 Marca: ${product.FCMarca}

¿Podrías darme más información?`;
    const mensajesGuardados = JSON.parse(localStorage.getItem('mensajesEnviados')) || [];
    const nuevoMensaje = {
      numero: sellerPhone,
      modelo: product.FCNombre,
      imagen: product.images?.[0] || '', // Usa la primera imagen
      fecha: new Date().toLocaleString(),
    };
    mensajesGuardados.push(nuevoMensaje);
    localStorage.setItem('mensajesEnviados', JSON.stringify(mensajesGuardados));

    window.open(
      `https://wa.me/${sellerPhone}?text=${encodeURIComponent(message)}`,
      '_blank'
    );
  };

  return (
    <button className="contact-seller-button" onClick={handleSendMessage}>
      Contactar vendedor
    </button>
  );
};

export default React.memo(SendMessage);
